<template>
  <div class="container-fluid p-0">
    <form method="post" ref="form" :data-url="submit_url" @submit.prevent="save">

      <app-form-group
          :label="$fieldLabel('Payment Gateway', 'name')"
          page="page"
          v-model="formData.payment_gateway_label"
          :placeholder="$placeholder('Payment Gateway', 'name')"
          :error-message="$errorMessage(errors, 'payment_gateway_name')"
      />

      <app-form-group
          :label="$fieldLabel('Payment Gateway', 'key')"
          page="page"
          v-model="formData.payment_gateway_key"
          :placeholder="$placeholder('Payment Gateway', 'key')"
          :error-message="$errorMessage(errors, 'payment_gateway_key')"
      />

      <app-form-group
          :label="$fieldLabel('Payment Gateway', 'secret')"
          page="page"
          v-model="formData.payment_gateway_secret"
          :placeholder="$placeholder('Payment Gateway', 'secret')"
          :error-message="$errorMessage(errors, 'payment_gateway_secret')"
      />

      <div class="form-group mt-5 mb-0">
        <app-submit-button @click="submitData" :loading="loading"/>
      </div>
    </form>
  </div>
</template>

<script>
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {axiosGet, urlGenerator} from '../../../../../common/Helper/AxiosHelper'
import {PAYMENT_SETTINGS_LIST} from "../../../../../common/Config/apiUrl";

export default {
  name: "PaymentSettings",
  components: {},
  mixins: [FormMixin, FormHelperMixins],
  data() {
    return {
      alias: false,
      formData: {
        payment_gateway_label: '',
        payment_gateway_key: '',
        payment_gateway_secret: '',
      },
      submit_url: 'admin/app/settings/payment-settings',
    }
  },
  props: {
    props: {
      default: function () {
        return {
          alias: 'app'
        }
      }
    }
  },
  methods: {
    submitData() {
      this.loading = true;
      this.message = '';
      this.errors = {};
      this.save(this.formData);
    },

    // afterSuccess({data}) {
    //   if (this.promptActivable) {
    //     this.promptIsActive = true;
    //   }
    //   this.testMailButton = true;
    //   this.scrollToTop();
    //   this.toastAndReload(data.message);
    // },

    getPaymentSettings() {
      const url = `${PAYMENT_SETTINGS_LIST}`;
      axiosGet(url).then(({data}) => {

        // if (!Object.keys(data).length) {
        //
        // }else {
        //
        // }

        // if (data.provider) {
        //   this.formData = Object.keys(data).length ? data : {provider: 'smtp'};
        // }else {
          this.formData = data
        // }
      });
    },

    // triggerConfirm() {
    //   window.location = urlGenerator(TENANT_NOTIFICATION_SETTINGS_FRONT_END);
    // }
  },
  created() {
    this.$store.dispatch('getConfig');
    this.getPaymentSettings();
  },
  // watch: {
  //   'formData.provider': {
  //     handler: function (provider) {
  //       this.getMailSettings(provider);
  //     },
  //     immediate: true
  //   },
  // }
}
</script>

<style scoped>

</style>
